<template>
    <span class="tw-inline-flex tw-border-solid tw-border-border-color" :class="dividerClasses"></span>
</template>

<script>
export default {
    name: 'Divider',
    props: {
        orientation: {
            type: String,
            default: 'horizontal',
            validator(value) {
                return ['horizontal', 'vertical'].includes(value);
            },
        },
    },
    computed: {
        dividerClasses() {
            return this.orientation === 'horizontal' ? 'tw-border-t' : 'tw-border-l';
        },
    },
};
</script>
